<template>
  <ul class="navbar-nav mr-auto">
    <li class="nav-item active">            	
        <router-link class="nav-link " exact :to="{ name: 'home' }">Trang chủ</router-link>
    </li>
    <li class="nav-item">
        <router-link class="nav-link " exact  :to="{ name: 'introduce', params: { slug: 'gioi-thieu' } }">Giới thiệu</router-link>
    </li>
    <li class="nav-item dropdown">        
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Sản phẩm
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <ul>
              <li v-for="(category, index) of categories" :key="index">
                <router-link exact  :to="{  name: 'productByCategory',  params: { slug: category.seoName }  }"  class="dropdown-item" >
                    {{category.name}}
                </router-link>
              </li> 
            </ul>
        </div>
    </li>
    <li class="nav-item">
        <router-link class="nav-link " exact  :to="{  name: 'page', params: { slug: 'huong-dan-mua-hang' }}">Hướng dẫn mua hàng</router-link>
    </li>
    <li class="nav-item">
        <router-link class="nav-link " exact  :to="{  name: 'page', params: { slug: 'huong-dan-thanh-toan' }}">Hướng dẫn thanh toán</router-link>
    </li>
    <li class="nav-item">
        <router-link class="nav-link " exact  :to="{  name: 'page', params: { slug: 'tai-lieu-ky-thuat' }}">Tài liệu kỹ thuật</router-link>
    </li>
    <li class="nav-item">
        <router-link class="nav-link " exact  :to="{  name: 'news-list',  params: { slug: 'tin-tuc' }}">Tin tức</router-link>
    </li>
    <li class="nav-item">
        <router-link class="nav-link" exact :to="{  name: 'contact',  params: { slug: 'lien-he' }}">Liên hệ</router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: "RwvMenu",
  props: {
    categories: Array
  }
};
</script>